module.exports = __webpack_public_path__ + "img/11.4799e396.png";